import { ELandingType } from '../../types/landingType';
import { getSteps as getInsuranceSteps } from '../activateInsurance/getSteps';
import { getSteps as getJoinOtaLegalShortSteps } from '../joinOtaLegalShort/getSteps';
import { getJoinOtaSteps } from '../joinOtaIndividual/getJoinOtaSteps';
import { getBusinessEntityFlowSteps } from '../businessEntityFlow/getSteps';

export const getSteps = (landingType: ELandingType) => {
  switch (landingType) {
    case ELandingType.ActivateInsurance:
      return getInsuranceSteps();
    case ELandingType.JoinOtaLegalShort:
      return getJoinOtaLegalShortSteps();
    case ELandingType.JoinOtaCian:
      return getJoinOtaSteps({ landingType: ELandingType.JoinOtaCian });
    case ELandingType.BusinessEntityFlow:
      return getBusinessEntityFlowSteps();
    default:
      return [];
  }
};
